import { render, staticRenderFns } from "./HemisphereLight.vue?vue&type=template&id=2dbe142c&"
import script from "./HemisphereLight.vue?vue&type=script&lang=js&"
export * from "./HemisphereLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports